



import Page from '../PostSales/postsalesuser/aftersale/aftersale.vue'
export default {
  name: 'aftersaleRD',
  components: { Page },
}
